<template>
  <content-page back>
    <template #header>
      <div class="pl-2" style="font-size: 20px; font-weight: bold">
        Referrer App Privacy Policy
      </div>
    </template>

    <PrivacyPolicy />

  </content-page>
</template>

<script>
  import { ContentPage } from '@/components/pages'
  import PrivacyPolicy from '@/components/documents/Privacy_2025_08_28'

  export default {
    components: { ContentPage, PrivacyPolicy },
  }
</script>